import { t } from '@lingui/core/macro'
import { Button, Tooltip } from '@tecsinapse/cortex-react'
import clsx from 'clsx'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { FiPlusCircle } from 'react-icons/fi'
import { IoEye } from 'react-icons/io5'
import { Roles } from '@/core/enums/roles'
import { AccessControl } from '@/core/utils/access-control'
import { OptionSelect } from '@/core/utils/types'
import { UsuarioDialogByGruposUsuarios } from '@/core/components/usuario-dialog-by-grupos-usuarios'
import { extrairIdsSelecionados } from '@/core/utils/extrair-ids-selecionados'
import {
  FormMultiSelectFavorito,
  GrupoUsuariosFavoritoOption
} from './form-multi-select-favorito'
import { useFormContext, useWatch } from 'react-hook-form'
import { useGruposUsuariosAtivos } from '@/core/hooks/use-grupos-de-usuarios'
import { GrupoUsuariosEdicaoDialog } from '@/core/components/grupo-usuarios-edicao-dialog'

interface FormSelectGrupoUsuariosProps {
  name: string
  selection?: boolean
  nameUsuariosRemovidos?: string
  customOnChange?: (option: GrupoUsuariosFavoritoOption[]) => void
  className?: string
  disabled?: boolean
  label?: string
  disableActions?: boolean
}

export const FormSelectGrupoUsuarios = ({
  name,
  selection,
  nameUsuariosRemovidos,
  customOnChange,
  className,
  disabled,
  label,
  disableActions = false
}: FormSelectGrupoUsuariosProps) => {
  const { setValue } = useFormContext()
  const values = useWatch()
  const { gruposOptions } = useGruposUsuariosAtivos()

  const selectedGroups = values?.[name] ?? []
  const idGruposSelecionados =
    extrairIdsSelecionados<OptionSelect>(selectedGroups)
  const idsUsuariosRemovidos = values?.[nameUsuariosRemovidos ?? ''] ?? []

  const [abrirNovoGrupo, setAbrirNovoGrupo] = useState(false)
  const [abrirDestinatarios, setAbrirDestinatarios] = useState(false)
  return (
    <div className={clsx('flex flex-row items-center space-x-deca', className)}>
      <FormMultiSelectFavorito
        name={name}
        options={gruposOptions}
        disabled={disabled}
        label={label ?? t`Grupo de Usuários`}
        withSearch
        customOnChange={customOnChange}
      />
      {!disableActions ? (
        <>
          {idGruposSelecionados && idGruposSelecionados.length > 0 ? (
            <Tooltip text={t`Ver destinatários`}>
              <Button
                disabled={disabled}
                onClick={() => setAbrirDestinatarios(true)}
                type={'button'}
                variants={{ size: 'square' }}
              >
                <IoEye />
              </Button>
            </Tooltip>
          ) : null}
          <AccessControl
            allowedRoles={[Roles.PORTAL_MANUTENCAO_GRUPOS_USUARIOS]}
            allowedUserTypes={undefined}
          >
            <Tooltip text={t`Criar novo grupo`}>
              <Button
                disabled={disabled}
                variants={{ size: 'square' }}
                onClick={() => setAbrirNovoGrupo(true)}
                type={'button'}
              >
                <FiPlusCircle />
              </Button>
            </Tooltip>
          </AccessControl>
          {createPortal(
            <UsuarioDialogByGruposUsuarios
              idsGrupos={idGruposSelecionados}
              idsUsuariosNaoSelecionados={idsUsuariosRemovidos}
              abrir={abrirDestinatarios}
              setAbrir={setAbrirDestinatarios}
              setValue={setValue}
              nameUsuariosRemovidos={nameUsuariosRemovidos}
              selection={selection}
              mensagem={t`Desmarque usuários para removê-los da lista de destinatários.`}
            />,
            document.body
          )}
          {createPortal(
            <GrupoUsuariosEdicaoDialog
              setAbrir={setAbrirNovoGrupo}
              abrir={abrirNovoGrupo}
              handleCloseDialog={(grupoCriado: OptionSelect) => {
                if (grupoCriado.value) {
                  setValue(name, [...values[name], grupoCriado])
                }
                setAbrirNovoGrupo(false)
              }}
            />,
            document.body
          )}
        </>
      ) : null}
    </div>
  )
}
